module.exports = __webpack_public_path__ + "img/chevron-down-white.a292baa.svg";